import { Rights } from '@frontend/common';
import React from 'react';

import SelectInputV2, { SelectInputV2Props } from '../select/select-input-v2/select-input-v2.component';

const ID = 'right-select';
export interface RightsSelectProps extends Omit<SelectInputV2Props<Rights>, 'options'> {}
export const RightSelect = (props: RightsSelectProps) => {
    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable}
            className={props.className}
            options={Object.values(Rights).map((c) => ({ label: c, value: c }))}
            value={props.value}
            label={props.label || 'Right'}
            required={props.required}
            onSelect={props.onSelect}
        />
    );
};
